<template>
  <b-container class="wrap-detail-archive">
    <b-row class="box-head">
      <b-col
        cols="12"
        md="8"
        class="box-breadcrumb"
      >
        <b-breadcrumb :items="breadcrumbs" />
      </b-col>
      <b-col
        cols="12"
        md="4"
        class="box-back-btn"
      >
        <button @click.prevent="goBack()">
          Back To Archive
        </button>
      </b-col>
    </b-row>

    <div class="wrap-content">
      <div
        v-for="archives in archivesList"
        :key="archives.id"
        class="box-content"
      >
        <div
          v-for="sub in archives.subcategory"
          :key="sub.id"
          class="box-section"
        >
          <div class="box-title">
            <div class="box"></div>
            <h2>{{ sub.name }}</h2>
          </div>
          <!-- {{ sub.achive }} -->
          <b-row
            v-if="sub.achive"
            class="justify-content-md-center"
          >
            <b-col
              class="col"
            >
              No Awards
            </b-col>
          </b-row>
        </div>
      </div>
      <div class="box-view-more">
        <button>View More</button>
      </div>
    </div>
  </b-container>
</template>

<script>
import { mapState } from 'vuex'

export default {
  data () {
    return {
      breadcrumbs: [
        {
          text: 'Home',
          to: {
            name: 'home'
          }
        },
        {
          text: 'Archive',
          to: {
            name: 'archive'
          }
        },
        {
          text: ''
        }
      ],
      title: ''
    }
  },

  computed: {
    ...mapState({
      categorys: state => state.archive.categorys,
      archivesList: state => state.archive.archivesList,
      contents: state => state.archive.contents
    })
  },

  methods: {
    checkCateName () {
      if (this.archivesList) {
        this.archivesList.forEach(item => {
          this.breadcrumbs[2].text = item.name
          this.title = item.name
        })
      }
    },

    goBack () {
      this.$router.go(-1)
    }
  },

  created () {
    if (!this.categorys) {
      this.$store.dispatch('archive/getCate')
    }

    const id = this.$route.params.id
    this.$store.dispatch('archive/getList', id)
  },

  watch: {
    archivesList (data) {
      // data.forEach(item => {
      //   item.category.forEach(cate => {
      //     let id = cate.id
      //     console.log(cate.id)
      //     this.$store.dispatch('archive/getContent', id)
      //   })
      // })

      this.checkCateName()
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/variables.scss';

.wrap-detail-archive {
  .box-head {
    padding: 22px 0;
    border-bottom: 1px solid #CCC;

    .box-breadcrumb {
      display: flex;
      align-items: center;

      .breadcrumb {
        margin: 0;
        padding: 0;
        background: none;

        li {
          font-size: 1.25rem;

          a {
            color: black;
          }
        }
      }
    }

    .box-back-btn {
      margin-top: 22px;

      @media only screen and (min-width: $break-m) {
        margin-top: 0;
      }

      button {
        width: 100%;
        background-color: #CCC;
        padding: 12px 0;
        font-size: 1.25rem;
      }
    }
  }

  .wrap-content {
    padding: 22px 0 0 0;

    .box-content {
      .box-section {
        .box-title {
          .box {
            float: left;
            margin-top: 10px;
            width: 15px;
            height: 15px;
            background-color: $active;
          }

          h2 {
            margin-left: 22px;
          }
        }

        .row {
          padding: 22px 0;
          .col {
            text-align: center;
          }
        }
      }
    }

    // h1 {
    //   font-size: 2.5rem;
    //   color: #6D6E71;
    // }

    // .box-title {
    //   display: flex;
    //   justify-content: flex-start;
    //   align-items: center;
    //   padding: 10px 0 22px 0;

    //   .box {
    //     width: 15px;
    //     height: 15px;
    //     background-color: $active;
    //   }

    //   h2 {
    //     margin-left: 12px;
    //     padding: 12px 0;
    //     width: 100%;
    //     font-size: 1.75rem;
    //     border-bottom: 1px solid #CCC;
    //   }
    // }

    // .box-cover {
    //   .col {
    //     a {
    //       img {
    //         width: 100%;
    //         height: auto;
    //         background-color: $light;
    //       }
    //     }
    //   }
    // }

    // .box-view-more {
    //   display: flex;
    //   justify-content: center;
    //   margin: 22px 0;

    //   button {
    //     padding: 12px 42px;
    //     background-color: $active;
    //     font-size: 1.25rem;
    //     color: white;
    //   }
    // }

    // .box-content {
    //   h2 {
    //     margin-bottom: 12px;
    //     font-size: 2.75rem;
    //     color: $active;
    //   }

    //   .box-context {
    //     margin-bottom: 22px;

    //     .box {
    //       display: inline-block;
    //       // margin-top: 8px;
    //       width: 15px;
    //       height: 15px;
    //       background-color: $active;
    //     }

    //     .box-text {
    //       display: inline-block;
    //       margin-top: -32px;
    //       margin-left: 22px;

    //       h3 {
    //         font-size: 1.75rem;
    //       }

    //       p {
    //         line-height: 0.8;
    //         font-size: 1.25rem;
    //       }
    //     }
    //   }
    // }
  }
}
</style>
